import { api as apiExports } from '../api';
import { routes } from "../api/routes";

import axios from 'axios';
import { environment as env, environment } from '../../environments/environment';

const {
    Interceptor: api,
    // routes
} = apiExports;


export const getAllLocomotive = async (payload, headers) => {

    return await api.post(
        routes.Locomotive.getAllLocomotive,
        payload,
        headers
    );
};
export const getTicketCategory = async (id, payload, headers) => {
    return await api.get(
        routes.Locomotive.getTicketCategory + `/${id}`,
        payload,
        headers
    );
};
export const getAllWorkOrders = async (payload, headers) => {
    const { params } = payload;
    return await api.post(
        routes.Locomotive.getAllWorkOrders.concat(params),
        payload,
        headers
    );
};
export const getDatePicker = async (payload, headers) => {
    const { query } = payload; // Assuming the query is provided in the payload
    const Query = query ? `?${new URLSearchParams(query).toString()}` : '';
    return await api.get(
        routes.Locomotive.getDatePicker + Query,
        payload,
        headers
    );
};
export const getDatePickerUpdated = async ({ query, payload }, headers) => {
    const Query = query ? `?${new URLSearchParams(query).toString()}` : '';
    return await api.post(
        routes.Locomotive.getDatePickerUpdated + Query,
        payload,
        headers
    );
};

export const getAllInspections = async (type) => {
    return await api.get(
        type ? routes.Locomotive.allInspections + `?type=${type}` : routes.Locomotive.allInspections
    );
};

export const getAllEquipInspectionHistory = async (payload) => {
    return await api.post(
        routes.Locomotive.allEquipInspectionHistory,
        payload
    );
};



export const ExportAllEquipInspectionHistory = async (payload, headers) => {




    try {
        const AuthorizationExtracted = localStorage.getItem('access_jwt');
        headers = {
            ...headers,
            Authorization: AuthorizationExtracted
        };
        const response = await axios.post(
            env.apiPath.concat(routes.Locomotive.exportEquipInspectionHistory),
            payload,
            { responseType: 'blob', headers },
        );

        return response.data;
    } catch (error) {
        console.error('Error fetching PDF content:', error);
        throw error;
    }
};


export const workCompletedTable = async (payload, headers) => {


    try {
        const { query } = payload; // Assuming the query is provided in the payload
        const Query = query ? `?${new URLSearchParams(query).toString()}` : '';

        const AuthorizationExtracted = localStorage.getItem('access_jwt');
        headers = {
            ...headers,
            Authorization: AuthorizationExtracted
        };

        const response = await axios.get(
            env.apiPath.concat(routes.Locomotive.workCompletedTable.concat(Query)),
            { responseType: 'blob', headers },
            payload, // Specify response type as 'arraybuffer' for binary data

        );

        return response.data;
    } catch (error) {
        console.error('Error fetching PDF content:', error);
        throw error;
    }



};
export const workCompletedTableExport = async (data = {}, headers) => {

    const { query, payload } = data;

    try {
        const Query = query ? `?${new URLSearchParams(query).toString()}` : '';
        const AuthorizationExtracted = localStorage.getItem('access_jwt');
        headers = {
            ...headers,
            Authorization: AuthorizationExtracted
        };
        const response = await axios.post(
            env.apiPath.concat(routes.Locomotive.workCompletedTableExport.concat(Query)),
            payload,
            { responseType: 'blob', headers },
        );

        return response.data;
    } catch (error) {
        console.error('Error fetching PDF content:', error);
        throw error;
    }



};
export const updateStatus = async (id, payload, headers) => {
    return await api.put(
        routes.Locomotive.updateStatus + `/${id}`,
        payload,
        headers
    );
};
export const updateApproval = async (payload, headers) => {
    return await api.put(
        routes.Locomotive.updateApproval,
        payload,
        headers
    );
};
export const updateWorkOrderById = async (id, payload, headers) => {
    return await api.put(
        routes.Locomotive.updateWorkOrder + `/${id}`,
        payload,
        headers
    );
};
export const Saveapi = async (id, payload, headers) => {
    return await api.post(
        routes.Locomotive.Saveapi + `/${id}`,
        payload,
        headers
    );
};
export const DropDownApi = async (id, payload, headers) => {
    return await api.get(
        routes.Locomotive.DropDownApi,
        payload,
        headers
    );
};

export const EnterByTask = async (id, payload, headers) => {
    return await api.put(
        routes.Locomotive.EnterByTask + `/${id}`,
        payload,
        headers
    );
};
export const partSubmitApi = async (id, payload, headers) => {
    return await api.put(
        routes.Locomotive.partSubmitApi + `/${id}`,
        payload,
        headers
    );
};

export const getWorkOrderById = async (id, payload, headers) => {
    return await api.get(
        routes.Locomotive.getWorkOrderById + `/${id}`,
        payload,
        headers
    );
};
export const HistoryTable = async (id, filter) => {

    return await api.get(
        routes.Locomotive.HistoryTable + `/${id}?search=${filter?.search}&toggle=${filter.toggle}`,
    );
};
export const getEquipmentListing = async (payload, headers) => {

    return await api.post(
        routes.Locomotive.getEquipmentLookup,
        payload,
        headers
    );
};

export const createLocomotive = async (payload, headers) => {
    return await api.post(
        routes.Locomotive.createLocomotive,
        payload,
        headers
    );
};
export const exportLocomotive = async (payload, headers) => {
    return await api.post(
        routes.Locomotive.exportLocomotive,
        payload,
        headers
    );
};
export const exportLocomotiveTicket = async (payload, headers) => {
    const { roleId, params } = payload;
    return await api.get(
        routes.Locomotive.exportTicketLocomotive.concat(roleId, params),
        payload,
        headers
    );
};
export const getDatasheetData = async (id, params, payload, headers) => {
    // const { id } = payload;

    return await api.get(
        routes.Locomotive.getDatasheetData + `/${id}?add=${params}`,
        payload,
        headers
    );
};
export const getDatasheetTableData = async (id, tableId, payload, headers) => {
    return await api.put(
        routes.Locomotive.getDatasheetTableData + `/${id}` + `/${tableId}`,
        payload,
        headers
    );
}
export const exportWorkOrders = async (payload, headers) => {
    const { params } = payload;
    return await api.post(
        routes.Locomotive.WoOrdersExport.concat(params),
        payload,
        headers
    );
};
export const exportAuditTab = async (payload, headers) => {
    const { params } = payload;
    return await api.get(
        routes.Locomotive.exportAuditTab.concat(params),
        payload,
        headers
    );
};
export const equipmentExport = async (payload, headers) => {
    return await api.post(
        routes.Locomotive.equipmentExportLocomotive,
        payload,
        headers
    );
};
export const updateLocomotive = async (id, payload, headers) => {
    return await api.put(
        routes.Locomotive.updateLocomotive + `/${id}`,
        payload,
        headers
    );
}

export const getLocomotiveByID = async (id, payload, headers) => {
    return await api.get(
        routes.Locomotive.getLocomotiveById + `/${id}`,
        payload,
        headers
    );
};
export const LastFedralTableApiFunction = async (id, payload, headers) => {
    return await api.get(
        routes.Locomotive.LastFedralTable + `/${id}`,
        payload,
        headers
    );
};
// /employee/locomotive/federal_inspection

export const updateEquipmentById = async (id, payload, headers) => {
    return await api.put(
        routes.Locomotive.updateEquipId + `/${id}`,
        payload,
        headers
    );
};
export const updateTableLocation = async (payload, headers) => {
    return await api.get(
        routes.Locomotive.TableLocation,
        payload,
        headers
    );
};

export const updateEquipmentLocation = async (id, payload, headers) => {
    return await api.put(
        routes.Locomotive.updateEquipLocation + `/${id}`,
        payload,
        headers
    );
};

export const updateEquipmentStatus = async (id, payload, headers) => {
    return await api.put(
        routes.Locomotive.updateEquipStatus + `/${id}`,
        payload,
        headers
    );
};

export const getAllStatus = async (payload, headers) => {

    return await api.get(
        routes.Locomotive.getAllStatus,
        payload,
        headers
    );
};
export const getAllStatusUpdated = async (payload, headers) => {
    const queryParams = { status: 'ALL' };

    return await api.get(
        `${routes.Locomotive.getAllStatus}?${new URLSearchParams(queryParams)}`,
        payload,
        headers
    );
};

export const getAllLocomotiveTicketSources = async (payload, headers) => {
    return await api.get(
        routes.Locomotive.ticketSource,
        payload,
        headers
    );
};



export const getAllNotes = async (id, payload, headers) => {
    return await api.get(
        routes.Locomotive.getAllNotes + `/${id}`,
        payload,
        headers
    );
};
export const getLastCompletedWorkOrders = async (id, status) => {
    return await api.get(
        routes.Locomotive.getWorkOrderTable + `/${id}` + `?status=${status}`,
    );
};


export const getWorkOrderTable = async (id, payload, headers) => {
    return await api.get(
        routes.Locomotive.getWorkOrderTable + `/${id}`,
        payload,
        headers
    );
};

export const submitLastCompletedTask = async (id, payload, headers) => {
    return await api.put(
        routes.Locomotive.lastTastCompleted + `/${id}`,
        payload,
        headers
    );
};

export const getAllNotesWorkOrder = async (id, payload, headers) => {
    return await api.get(
        routes.Locomotive.getAllNotesWorkOrder + `/${id}`,
        payload,
        headers
    );
}


export const AddLocomotiveNotes = async (id, payload, headers) => {
    return await api.post(
        routes.Locomotive.createNote + `/${id}`,
        payload,
        headers
    );
};
export const AddWorkOrderNotes = async (id, payload, headers) => {
    return await api.post(
        routes.Locomotive.WorkOrderNotes + `/${id}`,
        payload,
        headers
    );
};
export const CloseCompleteWo = async (id, payload, headers) => {
    return await api.put(
        routes.Locomotive.CloseCompleteWo + `/${id}`,
        payload,
        headers
    );
};


export const updateFraStatus = async (id, payload, headers) => {
    return await api.put(
        routes.Locomotive.updateFra + `${id}`,
        payload,
        headers
    );
};

export const createContact = async (id, payload, headers) => {
    // {
    //     "CustName": "afsah",
    //     "CustMobile": "a",
    //     "CustOffice": "a",
    //     "CustEmail": "a",
    //     "CustTitle": "a"
    // }
    return await api.post(
        routes.Locomotive.createContact + `/${id}`,
        payload,
        headers
    );
};
export const deleteContact = async (id, payload, headers) => {
    return await api.post(
        routes.Locomotive.deleteContact + `/${id}`,
        payload,
        headers
    );
};
export const getAllContacts = async (id, history, payload, headers) => {
    return await api.get(
        routes.Locomotive.getAllContactList + `/${id}?history=${history}`,
        payload,
        headers
    );
};
export const createLeaseLocomotive = async (id, payload, headers) => {
    return await api.post(
        routes.Locomotive.createLease + `/${id}`,
        payload,
        headers
    );
};
export const getAllCustomerLocomotive = async (id, payload, headers) => {
    return await api.get(
        routes.Locomotive.getCust,
        payload,
        headers
    );
};
export const getAllLocomotiveLease = async (id, payload, headers) => {
    return await api.get(
        routes.Locomotive.getAllLease + `/${id}`,
        payload,
        headers
    );
};

export const getEquipmentLookupWordOrders = async (id, payload, headers) => {
    return await api.get(
        routes.Locomotive.workOrders + `/${id}`,
        payload,
        headers
    );
};

export const getAllWorkOrderOpen = async (id, payload, headers) => {
    return await api.get(
        routes.Locomotive.getAllWorkOrderOpen + `/${id}`,
        payload,
        headers
    );
};

export const getInspectionHistory = async (id, headers) => {
    return await api.get(
        routes.Locomotive.inspection + `/${id}`,
        headers
    );
};

export const getOOSHistory = async (id, payload, headers) => {
    return await api.post(
        routes.Locomotive.oos_inspection + `/${id}`,
        payload,
        headers
    );
};

export const getOOSHistory_OOSCodes = async (headers) => {
    return await api.get(
        routes.Locomotive.oos_codes,
        headers
    );
};


export const editOOSInspectionHistory = async (id, payload, headers) => {
    return await api.put(
        routes.Locomotive.editOOSHistory + `/${id}`,
        payload,
        headers
    );
};

export const getLocomotiveCloseoutReason = async (id, payload, headers) => {
    return await api.get(
        routes.Locomotive.ticketCloseOutReason + `/${id}`,
        payload,
        headers
    );
};

export const updateLocomotiveTicket = async (id, payload, headers) => {
    return await api.put(
        routes.Locomotive.updateLocomotiveTicket + `/${id}`,
        payload,
        headers
    );
};

export const updateLocomotiveTicketModal = async (id, payload, headers) => {
    return await api.put(
        routes.Locomotive.updateLocomotiveTicketModalData + `/${id}`,
        payload,
        headers
    );
};
export const updateTicketCategory = async (id, payload, headers) => {
    return await api.put(
        routes.Locomotive.updateTicketCategory + `/${id}`,
        payload,
        headers
    );
};

export const gellAllLocomotiveLocations = async ({ params }, headers) => {
    return await api.get(
        routes.Locomotive.getAllLocations?.concat(params),
        headers
    );
};

export const equipWOCategory = async (id, payload, headers) => {
    return await api.get(
        routes.Locomotive.equipWOCategory,
        payload,
        headers
    );
}
export const CreateCategory = async (payload, headers) => {
    return await api.post(
        routes.Locomotive.createCategory
        ,
        payload,
        headers
    );
}

export const equipWOSubCategory = async (id, payload, headers) => {
    return await api.get(
        routes.Locomotive.equipWOSubCategory + `/${id}`,
        payload,
        headers
    );
}
export const fetchNotTerminatedEmployeesWRTDept = async () => {
    return await api.get(
        routes.Locomotive.notTerminatedEmployeesWRTDept + `/2`,
    );
}


export const CreateSubCategory = async (payload, headers) => {
    return await api.post(
        routes.Locomotive.CreatesubCategory
        ,
        payload,
        headers
    );
}
export const AddWoFormApi = async (payload, headers) => {
    return await api.post(
        routes.Locomotive.AddWoForm,
        payload,
        headers
    );
}
export const TicketFormApi = async (payload, headers) => {
    return await api.post(
        routes.Locomotive.TicketFormApi,
        payload,
        headers
    );
}

export const equipWOTaskCategory = async (id, payload, headers) => {
    return await api.get(
        routes.Locomotive.equipWOTaskCategory + `/${id}`,
        payload,
        headers
    );
}

export const equipWOPositonCategory = async (id, payload, headers) => {
    return await api.get(
        routes.Locomotive.equipWOPositonCategory + `/${id}`,
        payload,
        headers
    );
}
